/* eslint-disable max-lines-per-function */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
    Table, Container, Header, Tab, Checkbox
} from 'semantic-ui-react';
import { actions as departmentActions } from '../departments/sagaSlice';
import { actions as userActions } from './sagaSlice';
import { useProperties } from '~/properties';

const styles = {
    selectAllContainer: {
        display: 'inline-flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        margin: '-12px 0 0 -12px',
        width: 'calc(100% + 12px)'
    },
    flexChild: {
        margin: '12px 0 0 12px'
    }
};


const UserDepartment = props => {

    const {
        getDepartments,
        departments,
        user,
        match,
        readOneUser,
        propertyAccess,
        departmentAccess
    } = props;


    const { user_id } = match.params;
    const { data: properties } = useProperties();

    const togglePropertyAccess = (user_id, property_id, write_access = false, remove = false) => {

        const { properties } = user;

        if (remove) {
            propertyAccess({
                user_id,
                properties: properties.filter(access => access.id !== property_id)
            });

            return;
        }

        propertyAccess({
            user_id,
            properties: properties.concat({
                id: property_id,
                write_access
            })
        });

    };

    const toggleDepartmentAccess = (user_id, department_id, remove = false) => {

        const { departments } = user;

        if (remove) {
            departmentAccess({
                user_id,
                departments: departments.filter(access => access.id !== department_id)
            });

            return;
        }

        departmentAccess({
            user_id,
            departments: departments.concat({ id: department_id })
        });

    };

    useEffect(() => {
        getDepartments();
        readOneUser(user_id);
    }, [getDepartments, readOneUser, user_id]);

    if (!departments.length || !user) return null;

    const PropertiesAccess = () => (
        <Table>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell content='Property Name' />
                    <Table.HeaderCell textAlign='center' content='Has Read Access' />
                    <Table.HeaderCell textAlign='center' content='Manages Property' />
                </Table.Row>
                <Table.Row>
                    <Table.HeaderCell />
                    <Table.HeaderCell textAlign='center'>
                        <div style={styles.selectAllContainer}>
                            <div style={styles.flexChild}>
                                Select All
                                {/* READ ACCESS */}
                            </div>
                            <div style={styles.flexChild}>
                                <Checkbox
                                    checked={user.properties.length === properties.length}
                                    onChange={(e, { checked }) => {
                                        if (checked) {
                                            propertyAccess({
                                                user_id: user.id,
                                                properties
                                            });
                                        }
                                        else {
                                            propertyAccess({
                                                user_id: user.id,
                                                properties: []
                                            });
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>
                        <div style={styles.selectAllContainer}>
                            <div style={styles.flexChild}>
                                Select All
                                {/* WRITE ACCESS */}
                            </div>
                            <div style={styles.flexChild}>
                                <Checkbox
                                    checked={user.properties.filter(prop => prop.write_access).length === properties.length}
                                    onChange={(e, { checked }) => {
                                        if (checked) {
                                            propertyAccess({
                                                user_id: user.id,
                                                properties: properties.map(p => ({
                                                    ...p,
                                                    write_access: true
                                                }))
                                            });
                                        }
                                        else {
                                            propertyAccess({
                                                user_id: user.id,
                                                properties: properties.map(p => ({
                                                    ...p,
                                                    write_access: false
                                                }))
                                            });
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {properties.map(property => (
                    <Table.Row key={property.name}>
                        <Table.Cell content={property.name} />
                        <Table.Cell textAlign='center'>
                            <Checkbox
                                checked={hasAccess(user, 'properties', property.name)}
                                onChange={(e, { checked }) => {
                                    if (checked) {
                                        togglePropertyAccess(user.id, property.id);
                                    }
                                    else {
                                        togglePropertyAccess(user.id, property.id, false, true);
                                    }
                                }}
                            />
                        </Table.Cell>
                        <Table.Cell textAlign='center'>
                            <Checkbox
                                checked={hasAccess(user, 'properties', property.name, true)}
                                onChange={(e, { checked }) => {
                                    togglePropertyAccess(user.id, property.id, checked);
                                }}
                            />
                        </Table.Cell>
                    </Table.Row>
                ))}
            </Table.Body>
        </Table>
    );

    const DepartmentsAccess = () => (
        <Table>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell content='Department Name' />
                    <Table.HeaderCell content='Has Access' />
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {departments.map(department => (
                    <Table.Row key={department.name}>
                        <Table.Cell content={department.name} />
                        <Table.Cell>
                            <Checkbox
                                checked={hasAccess(user, 'departments', department.name)}
                                onChange={(e, { checked }) => {
                                    if (checked) {
                                        toggleDepartmentAccess(user.id, department.id);
                                    }
                                    else {
                                        toggleDepartmentAccess(user.id, department.id, true);
                                    }
                                }}

                            />
                        </Table.Cell>

                    </Table.Row>
                ))}
            </Table.Body>
        </Table>
    );

    return (
        <Container>
            <Header
                as='h2'
                color='grey'
                content='User Permissions'
                subheader={user.name}
            />
            <Tab menu={{
                secondary: true,
                pointing: true
            }} panes={[
                {
                    menuItem: 'Properties',
                    render: () => <Tab.Pane attached={false}><PropertiesAccess /></Tab.Pane>
                },
                {
                    menuItem: 'Departments',
                    render: () => <Tab.Pane attached={false}><DepartmentsAccess /></Tab.Pane>
                }
            ]} />
        </Container>
    );

};


const hasAccess = (user, type, name, write_access) => {

    if (write_access){

        return !!user[type].find(_type => _type.name === name)?.write_access;
    }

    return !!user[type].find(_type => _type.name === name);

};


const mapStateToProps = (state, ownProps) => ({
    departments: Object.values(state.departments.data),
    user: state.users.data[ownProps.match.params.user_id],
    properties: Object.values(state.properties.data)
});

const actions = {
    getDepartments: departmentActions.getDepartments,
    readOneUser: userActions.readOne,
    propertyAccess: userActions.propertyAccess,
    departmentAccess: userActions.departmentAccess
};

export default connect(mapStateToProps, actions)(UserDepartment);
